<template>
<div>
  <!-- <b-button v-b-toggle.customer-draft-slideout>Toggle Sidebar</b-button> -->
  <b-sidebar :no-header-close="true" :visible="visible" id="customer-draft-slideout" :title="slideOutTitle" right width="60vw" shadow aria-controls="customer-draft-slideout">
    <div class="px-3 py-2 m-t-30">
      <a href="#" @click.prevent="closeIt" class="closeBtn">
        <b-icon icon="x-circle-fill" font-scale="1"></b-icon> Close
      </a>

      
      <h3 class="m-b-30">Order no: {{ orderNo }} </h3>

      <section v-if="orderItemImages.length > 0" class="m-b-30">
        <h4>Customer Uploaded Files </h4>
        <b-row>
          <b-col cols="3" v-for="(file, index) in orderItemImages" v-bind:key="index" >
              <a :href="file" target="_blank"><b-img-lazy rounded  thumbnail fluid :src="file" alt="Customer Raw File"></b-img-lazy></a>
          </b-col>
        </b-row>
      </section>
     

      <div>
        <b-tabs content-class="mt-3" fill>
          <b-tab title="Send Draft" active>

            
            <div class="text-center" v-if="inprogress">
              <b-spinner variant="primary" label="Text Centered"></b-spinner>
            </div>
            <div v-else-if="!inprogress && files.length == 0">
              <b-jumbotron bg-variant="info" text-variant="white" border-variant="dark">
                <template v-slot:header>No Designs / Files found.</template>

                <template v-slot:lead>
                  Seems like the designers has not uploaded any files related to this order.
                </template>

                <hr class="my-4">

                <p>
                  Contact the designer to know more in details.
                </p>
              </b-jumbotron>
            </div>
            <section v-else-if="!inprogress && files.length > 0">

              
              <h3>Designed Files</h3>
              <div class="cus-draft-notice" v-if="downloadProgress">🙂 Hold on plz. Downloading...</div>
              <div  class="cus-draft-notice" v-if="showCopiedUrl">🙂 Url Copied</div>
              <b-card no-body :bg-variant="draftSendable ? 'dark' : 'light'" :text-variant="draftSendable ? 'light' : 'dark'" header-tag="header" footer-tag="footer" :border-variant="draftSendable ? 'dark' : 'primary'" v-for="file in files" v-bind:key="file.id" style="width: 100%; " class="m-b-20" :class="{alreadySent: alreadySentFilesId.includes(file.id) && !file.checked}">
                <section :class="{alreadySentInner: alreadySentFilesId.includes(file.id) && !file.checked}">
                  <b-row no-gutters>
                    <b-col md="3">
                      <div style="width: 100%; height: 100%; position: relative;">
                        <div style="position: absolute; width: 100%; left: 0; top: 0; bottom: 0;background-size: cover;" :style="{background: `url(${file.fileThumbUrl}) no-repeat center center`}"></div>
                      </div>

                    </b-col>
                    <b-col md="9">
                      <section class="p-l-20 p-t-20 p-r-20 p-b-20">
                        <b-card-text>
                          <h4>File name: {{ file.name }}</h4>
                          <div class="row m-b-20">
                            <div class="col-sm-4" v-if="file.SharableStatus">
                              <span>
                                <b-badge :style="{backgroundColor: file.SharableStatus.colorCode}">{{ file.SharableStatus ? file.SharableStatus.status : ""}}</b-badge>
                              </span>
                            </div>
                            <div class="col-sm-8">
                              <h5>Uploader: {{ file.User.firstName }} {{ file.User.lastName }}</h5>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12 m-b-20">
                              <h6>Last Updated: {{ moment(file.updatedAt).format('DD-MM-YYYY, h:mm a') }}</h6>
                            </div>
                            <div class="col-sm-6" v-if="draftSendable">
                              <b-form-checkbox size="lg" v-model="file.checked" name="check-button" switch>
                                Select Design
                              </b-form-checkbox>
                            </div>
                            <div class="col-sm-6" v-if="draftSendable">
                              <b-button  :href="file.fileUrl" variant="primary" class="float-right" target="_blank">View File</b-button>
                            </div>
                            <div class="col-sm-12" v-else>
                              <b-row>
                                <b-col cols="6">
                                    <b-button   variant="info" block class="float-right"  @click.prevent="downloadFile(file.fileUrl)">Download File</b-button>
                                    
                                </b-col>
                                <b-col cols="6">
                                    <b-button   variant="primary" block class="float-right"  v-clipboard:copy="file.fileUrl" v-clipboard:success="onCopy">Copy File Link</b-button>
                                </b-col>
                              </b-row>
                              
                              
                            </div>
                          </div>
                        </b-card-text>

                        
                      </section>
                    </b-col>
                  </b-row>
                </section>

              </b-card>

              

              <section class="customer-info-section" v-if="draftSendable">
  
                <h3>Customer Info</h3>
                <b-list-group class="m-b-30">
                  <b-list-group-item><strong>Customer Name:</strong> {{ order.customerData.first_name }} {{ order.customerData.last_name }}</b-list-group-item>
                  <b-list-group-item><strong>Customer Country:</strong> {{ order.customerData.default_address.country_name }} ({{ order.customerData.default_address.country_code }})</b-list-group-item>
                  <b-list-group-item><strong>Customer Email:</strong> {{ order.customerEmail }}</b-list-group-item>
                  <b-list-group-item>
                    <b-row>
                      <b-col md="3">
                        <strong class="editables">Send Draft to Email:</strong>
                      </b-col>
                      <b-col md="6">
                        <b-form-input v-model="email" placeholder="Enter email"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-list-group-item>
  
                  <b-list-group-item><strong>Customer Phone:</strong> {{ order.customerData.phone ?  order.customerData.phone : order.customerData.default_address.phone ?  order.customerData.default_address.phone : "No phone number given" }}</b-list-group-item>
                  <b-list-group-item>
  
                    <b-row>
                      <b-col md="3">
                        <strong class="editables">Send Draft SMS to:</strong>
                      </b-col>
                      <b-col md="6">
  
                        <b-form-group v-if="!numberValidationInProgress" class="mb-0" label-for="input-formatter" description="Number is processed to format it correctly.">
                          <b-form-input v-model="phone" description="The number is processed to detect the right format for the country." placeholder="Enter Phone"></b-form-input>
                        </b-form-group>
                        <div v-else>Processing Number. Please wait.</div>
                      </b-col>
                    </b-row>
  
                  </b-list-group-item>
                </b-list-group>
  
                <b-form-group label="SMS and email draft type to send to customer:">
                    <b-form-radio-group
                      id="draft-types-group"
                      v-model="draftTypeSelected"
                      :options="draftTypesOptions"
                      name="draft-types-group"
                    ></b-form-radio-group>
                  </b-form-group>
  
  
  
                <div class="m-b-20">
                  <b-button block variant="primary" style="font-size: 22px;" size="lg" :disabled="processing || numberValidationInProgress" @click="sendDraft">
                    <b-spinner small v-show="processing"></b-spinner>
                    <span class="sr-only" v-show="processing">Loading...</span>
                    <span v-show="!processing">Send Draft to Customer</span>
  
                  </b-button>
                </div>
  
                <div class="row m-b-30">
                  <div class="col-sm-6 offset-sm-6">
                    <h5>Completion Status</h5>
                    <b-list-group>
                      <b-list-group-item class="d-flex justify-content-between align-items-center">
                        Draft Status
                        <b-badge :variant="actionStatus.draft == 'Not Complete' ? 'default' : 'success'" pill>{{ actionStatus.draft }}</b-badge>
                      </b-list-group-item>
  
                      <b-list-group-item class="d-flex justify-content-between align-items-center">
                        Order Status
                        <b-badge :variant="actionStatus.status == 'Not Complete' ? 'default' : 'success'" pill>{{ actionStatus.status }}</b-badge>
                      </b-list-group-item>
  
                      <b-list-group-item class="d-flex justify-content-between align-items-center">
                        Order Tags
                        <b-badge :variant="actionStatus.tag == 'Not Complete' ? 'default' : 'success'" pill>{{ actionStatus.tag }}</b-badge>
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </div>
</section>

            </section>

          </b-tab>
          <b-tab :title="`(${drafts.drafts ? drafts.drafts.length : 0} sent) Drafts History `">
             <draft-history :history="drafts.drafts ? drafts.drafts : []" :in-process="inprogress"/>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </b-sidebar>
</div>
</template>

<script>
import CustomerDraftsService from '../../../services/customer-drafts.service'
import OrderStatusesService from '../../../services/order-statuses.service'
import OrderTagsService from '../../../services/order-tags.service'
const DraftHistory = () => import(/* webpackChunkName: "customer-draft.draft-history" */ './draft-history')

import axios from "axios";

import {
  removeDuplicates
} from '../../../helpers/array.helpers'
import EventBus from '../../../EventBus'
import DownloadFileMixin from '../mixins/download-file.mixin'
export default {
  mixins:[DownloadFileMixin],
  props: {
    slideOutTitle: {
      type: String,
      default: 'Manage Customer Drafts'
    },
    draftSendable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      orderNo: '',
      orderId: null,
      visible: false,
      inprogress: false,
      files: [],
      order: {},
      email: null,
      phone: null,
      processing: false,
      drafts: [],
      alreadySentFilesId: [],
      numberValidationInProgress: false,
      tagSettingInProgress: false,
      statusSettingInProgress: false,
      actionStatus: {
        draft: 'Not Complete',
        status: 'Not Complete',
        tag: 'Not Complete',
      },
      draftStatus: {
        name: 'Draft Sent',
        id: null
      },
      draftTypeSelected: null,
      draftTypesOptions: [
        {text: "Auto Detect", value: null},
        {text: "Digital Print", value: "digital_print"},
        {text: "Physical Canvas", value: "physical_canvas"},
      ],
      downloadProgress: false,
      showCopiedUrl: false
    }
  },
  components: {DraftHistory},
  mounted() {

    EventBus.$on("accessed-customer-draft", ({
      orderNo,
      orderId
    }) => {

      this.orderNo = orderNo;
      this.orderId = orderId;
      this.visible = true;

      console.log("<----<<< Draft slideout accessed >>>------>", this.orderNo, this.orderId)

      this.fetchOrderFilesFromD2DFolders();
      this.fetchDraftsHistory();
    })



  },
  methods: {
    async fetchOrderFilesFromD2DFolders() {
      console.log('Getting external files');
      this.resetData()

      this.inprogress = true;
      try {

        const files = await CustomerDraftsService.externalQueryOrderFiles(this.orderId);

        this.files = this.filterFiles(files.data.external.results)

        this.order = files.data.theOrder;
        this.inprogress = false;
        this.email = this.order.customerEmail;

        if (files.data.draftStatus) {
          this.draftStatus = {
            name: files.data.draftStatus.title,
            id: files.data.draftStatus.id,
          }
        }

        //this.phone = this.order.customerData.phone ? this.order.customerData.phone : this.order.customerData.default_address.phone ? this.order.customerData.default_address.phone : null;

        if ((this.order.customerData.default_address.phone || this.order.customerData.phone) && this.draftSendable) {
          try {

            this.numberValidationInProgress = true;
            const validateNumberAttempt = await CustomerDraftsService.validateNumberUsingTwilio({
              number: this.order.customerData.phone ? this.order.customerData.phone : this.order.customerData.default_address.phone ? this.order.customerData.default_address.phone : null,
              countryCode: this.order.customerData.default_address.country_code
            });

            this.numberValidationInProgress = false;

            this.phone = validateNumberAttempt.data.validatedNumber;

          } catch (errors) {
            console.log("number validation error", errors.response.data)
            this.numberValidationInProgress = false;
          }
        }

      } catch (e) {
        console.log("errors")
        this.inprogress = false;
      }
    },
    async fetchDraftsHistory() {
      try {
        let drafts = await CustomerDraftsService.fetchDraftLogs(this.orderId);
        this.drafts = drafts.data;

        // Get the ids of files already shared with customer
        drafts.data.drafts.forEach(draft => {
          
          if(draft.sendingMode.toLowerCase() == 'live'){
            draft.DraftFiles.forEach(file => {
              if (!this.alreadySentFilesId.includes(file.fileId)) {
                this.alreadySentFilesId.push(file.fileId)
              }
            })
          }
          
        });

      } catch (e) {
        console.log(e);
      }
    },
    async sendDraft() {
      let selectedDraft = false;
      this.files.forEach(file => {
        if (file.checked) {
          selectedDraft = true;
        }
      })
      if (!this.email && !this.phone) {
        this.$toasted.show("A email or a phone is required", {
          type: "error",
          action: {
            text: "Close",
            class: "toastBtnTxt",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
          duration: 3000,
        });
      } else if (!selectedDraft) {
        this.$toasted.show("Please select a draft to send", {
          type: "error",
          action: {
            text: "Close",
            class: "toastBtnTxt",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
          duration: 3000,
        });
      } else {
        let files = this.files.filter(file => {
          return file.checked;
        });

        let data = {
          userdata: {
            firstName: this.order.customerFirstName,
            lastName: this.order.customerLastName,
            country_name: this.order.customerData.default_address ? this.order.customerData.default_address.country_name : "",
            country_code: this.order.customerData.default_address ? this.order.customerData.default_address.country_code : "",
            phone: this.phone,
            email: this.email,
            orderNo: this.orderNo
          },
          files,
          orderId: this.order.id,
          storeId: this.order.shopify_store_id,
          draftType: this.draftTypeSelected
        }



        this.processing = true;
        try {
          const sendDraft = await CustomerDraftsService.sendDraft(data);
          console.log(sendDraft.data);

          this.$toasted.show(sendDraft.data.message, {
            type: "success",
            action: {
              text: "Close",
              class: "toastBtnTxt",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
            duration: 3000,
          });
          this.processing = false;

          this.actionStatus.draft = 'Complete';

          let statusData;
          if (this.draftStatus.id) {

            try {
              this.statusSettingInProgress = true;
              // Update the Status
              statusData = {
                statusId: this.draftStatus.id,
                orderId: this.orderId,
                note: "",
                statusName: this.draftStatus.name
              }

              const result = await OrderStatusesService.setStatus(statusData, this.orderId, "Order");
              this.statusSettingInProgress = false;
            } catch (e) {
              console.log(e)
              this.statusSettingInProgress = false;
            }

            this.actionStatus.status = 'Complete';

            // Update the Tag

            try {
              this.tagSettingInProgress = true;
              let tags = this.order.tags ? this.order.tags.split(',') : [];
              tags.push(`~${statusData.statusName.trim()}~`);
              tags = removeDuplicates(tags);

              let updateStatus = await OrderTagsService.updateOrderTags(this.orderId, tags);
              this.tagSettingInProgress = false;

              EventBus.$emit("customer-draft.sent", {order: updateStatus.data.theOrder});

            } catch (e) {
              this.tagSettingInProgress = false;
              console.log(e)
            }

            this.actionStatus.tag = 'Complete';

          }

          this.files.forEach(file => file.checked = false);

        } catch (errors) {
          this.processing = false;
          console.log(errors)
        }

      }

    },
    closeIt() {
      this.visible = false;
      this.resetData()

      this.files = [];
      this.email = null;
      this.phone = null;
      
    },
    resetData(){
      
      this.draftStatus = {
        name: 'Draft Sent',
        id: null
      }

      this.actionStatus = {
        draft: 'Not Complete',
        status: 'Not Complete',
        tag: 'Not Complete',
      }

      this.drafts=[]
      this.order = {}
    },
    filterFiles(filesArray){

      filesArray = filesArray.filter(file => {
         
         
         let isSameOrder = false;

         let result = (file.name.match(/\d+/g) || []).map(n => parseInt(n));
         result.forEach(digits => {

            console.log(`${digits}`.includes(`${this.orderNo}`), `${digits}`, `${this.orderNo}`, `${digits}`.length,  `${this.orderNo}`.length);

            if(`${digits}`.includes(`${this.orderNo}`) && `${digits}`.length == `${this.orderNo}`.length){
               console.log("This is it")
               isSameOrder = true;
            }
         });

         if(isSameOrder){
            console.log('Entered here')
            return true;
         }
         
      }).map(file => {
          return {
            ...file,
            ...{
              checked: false
            }
          }
        });



      return filesArray;
    },
    downloadFile(fileLink){
      this.downloadProgress = true;
      axios({
          url: fileLink, //your url
          method: 'GET',
          responseType: 'blob', // important
       }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileLink.split('/').pop()); //or any other extension
          document.body.appendChild(link);
          link.click();
      })
      .finally(() => {
        this.downloadProgress = false;
      })
    },
    onCopy(){
      this.showCopiedUrl = true;
      setTimeout(() => { this.showCopiedUrl = false}, 1000)
    }
  },
  computed:{
     orderItemImages(){
        let filesPreviewArray = [];
        if(this.order.ShopifyOrderItems){
            this.order.ShopifyOrderItems.forEach(item => { 
                item.properties.forEach(property => {
                   if(property.name.includes('uploadery')){
                      let thumb = `${this.getBase(property.value)}preview_${property.value.split('/').pop()}`
                      filesPreviewArray.push(thumb)
                   }
                })
            })
            return filesPreviewArray;
        }
        else{
          return []
        }
     }
  },
  beforeDestroy() {
    EventBus.$off("accessed-customer-draft")
   
  }
}
</script>

<style lang="scss" scoped>
.closeBtn {
  position: absolute;
  right: 10px;
  top: 10px;
  background-color: red;
  color: #fff;
  text-decoration: none;
  padding: 5px 10px;
}

.editables {
  margin-top: 5px;
  display: block;
}

.alreadySent {
  &::after {
    content: "Already Sent";
    position: absolute;
    right: 20px;
    top: 10px;
    color: rgb(255, 103, 97);
    font-size: 22px;
  }
}

.alreadySentInner {

  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
  transition: all 100ms ease;

  &:hover {
    -webkit-filter: blur(0);
    -moz-filter: blur(0);
    -o-filter: blur(0);
    -ms-filter: blur(0);
    filter: blur(0);
  }
}
.cus-draft-notice{
  position: fixed;
  bottom: 10px;
  right: 10px;
  background-color: rgba(0,0,0,0.6);
  color: #fff;
  z-index: 10;
  padding: 5px 10px;
}
</style>
